export default __webpack_public_path__ + "27ab9b78ca8ec249d47326c4907e2f6d.svg";